module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1r3n6n-1bd01ca4c0e67b33de7973501fd3f491.svg";